import { render } from "./TalkToMyDataStreaming.vue?vue&type=template&id=2900d16d&scoped=true"
import script from "./TalkToMyDataStreaming.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataStreaming.vue?vue&type=script&lang=js"

import "./TalkToMyDataStreaming.vue?vue&type=style&index=0&id=2900d16d&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2900d16d"]])

export default __exports__